@if (secondGroupButton) {
    <div class="float-right mr-4 flex">
        <button
            type="button"
            (click)="secondGroupButton.onClick()"
            [disabled]="areSecondaryButtonsDisabled"
            class="flex items-center border-2 border-solid border-blue text-blue font-bold text-sm h-11 px-3 transition-colors duration-100 hover:bg-blue-100 dark:hover:bg-black-700 disabled:opacity-40 disabled:cursor-not-allowed"
            [class.rounded]="secondGroupOtherButton.length === 0"
            [class.rounded-l]="secondGroupOtherButton.length > 0">
            {{ secondGroupButton.label | translate }}
        </button>
        @if (secondGroupOtherButton.length > 0) {
            <button
                type="button"
                [cdkMenuTriggerFor]="secondMenu"
                [cdkMenuPosition]="menuPositions"
                [disabled]="areSecondaryButtonsDisabled"
                class="flex items-center justify-center w-9 border-2 border-l-0 border-solid border-blue text-blue h-11 rounded-r transition-colors duration-100 hover:bg-blue-100 dark:hover:bg-black-700 disabled:opacity-40 disabled:cursor-not-allowed">
                <je-fa-icon name="chevron-down" [size]="'small'"></je-fa-icon>
            </button>
            <ng-template #secondMenu>
                <div cdkMenu class="z-100 bg-white dark:bg-black-800 border border-solid border-black-200 dark:border-black-600 rounded shadow-md py-1 min-w-40">
                    @for (otherButton of secondGroupOtherButton; track otherButton.id; let last = $last) {
                        <button
                            cdkMenuItem
                            type="button"
                            (click)="otherButton.onClick()"
                            [disabled]="areSecondaryButtonsDisabled"
                            class="w-full text-left px-4 py-2 text-sm font-bold text-blue hover:bg-blue-100 dark:hover:bg-black-700 disabled:opacity-40 disabled:cursor-not-allowed"
                            [class.border-b]="!last"
                            [class.border-solid]="!last"
                            [class.border-black-300]="!last">
                            {{ otherButton.label | translate }}
                        </button>
                    }
                </div>
            </ng-template>
        }
    </div>
}

@if (firstGroupButton) {
    <div class="float-right mr-4 flex">
        <button
            type="button"
            (click)="firstGroupButton.onClick()"
            [disabled]="areSecondaryButtonsDisabled"
            class="flex items-center border-2 border-solid border-blue text-blue font-bold text-sm h-11 px-3 transition-colors duration-100 hover:bg-blue-100 dark:hover:bg-black-700 disabled:opacity-40 disabled:cursor-not-allowed"
            [class.rounded]="firstGroupOtherButton.length === 0"
            [class.rounded-l]="firstGroupOtherButton.length > 0">
            {{ firstGroupButton.label | translate }}
        </button>
        @if (firstGroupOtherButton.length > 0) {
            <button
                type="button"
                [cdkMenuTriggerFor]="firstMenu"
                [cdkMenuPosition]="menuPositions"
                [disabled]="areSecondaryButtonsDisabled"
                class="flex items-center justify-center w-9 border-2 border-l-0 border-solid border-blue text-blue h-11 rounded-r transition-colors duration-100 hover:bg-blue-100 dark:hover:bg-black-700 disabled:opacity-40 disabled:cursor-not-allowed">
                <je-fa-icon name="chevron-down" [size]="'small'"></je-fa-icon>
            </button>
            <ng-template #firstMenu>
                <div cdkMenu class="z-100 bg-white dark:bg-black-800 border border-solid border-black-200 dark:border-black-600 rounded shadow-md py-1 min-w-40">
                    @for (otherButton of firstGroupOtherButton; track otherButton.id; let last = $last) {
                        <button
                            cdkMenuItem
                            type="button"
                            (click)="otherButton.onClick()"
                            [disabled]="areSecondaryButtonsDisabled"
                            class="w-full text-left px-4 py-2 text-sm font-bold text-blue hover:bg-blue-100 dark:hover:bg-black-700 disabled:opacity-40 disabled:cursor-not-allowed"
                            [class.border-b]="!last"
                            [class.border-solid]="!last"
                            [class.border-black-300]="!last">
                            {{ otherButton.label | translate }}
                        </button>
                    }
                </div>
            </ng-template>
        }
    </div>
}
